<template>

	<button class="button button-icon white" :class="{active:handler=='italic'}" @click="toggle">
		<font-icon icon="italic" />
	</button>

</template>
<style scoped>

.button {
}
.button.active {
	border:3px solid #7855F2 !important;
}

</style>

<script>

export default {
	props:['value'],
	data(){
		return {
			handler:'',
		}
	},
	methods:{
		toggle(){
			this.handler = this.handler=='italic'? 'normal' : 'italic';
			this.$emit('input',this.handler);
		}
	},
	mounted(){
		this.handler = this.value || 'normal';
	},

}
</script>